<template>



    <div class="modal modal-active">
      <div class="modal-dialog">
         <div class="modal-content">
           <div class="modal-header">
             <div class="modal-title">{{_lang('Save template') }}</div>
             <span class="close" @click="close">&times;</span>
          </div>
           <div class="modal-body">

               <form @submit.prevent="onSubmit" class="form-inline">
                    <select v-model="template_id" class="form-control" @change="change">
                        <option v-for="template in templates" :value="template.id">{{template.name}}</option>
                        <option value="">(new template)</option>
                    </select>
                    <input class="form-control ml-2 mr-2" type="text" v-model="name" required>
                   <button type="submit" class="btn btn-primary">Save</button>
               </form>

           </div>
         </div>
       </div>
    </div>


</template>

<script>
import axios from 'axios';
export default {
    props:['project'],

    data(){
        return {
            name:'',
            template_id:'',
        }
    },
    computed:{
      templates(){
        return this.$store.getters.templates
      }

    },
    methods:{

      close(){
          this.$emit('close');
      },
      change(e){
        if(this.template_id){
           this.name = e.target.querySelector('option[value="'+this.template_id+'"]').text
        } else {
          this.name = '';
        }
      },
      onSubmit(){

        axios({
            method: 'post',
            url: '/api/templates',
            data: {
              template_id:this.template_id,
              project_id:this.project.id,
              name:this.name,
            }
        }).then((res) => {
            toastr('Template sucessfully saved')
            this.$store.dispatch('getTemplates');
            this.close();
        });

      },
    },
    mounted(){


      this.$store.dispatch('getTemplates');
        // this.domain = this.project.domain;

    },


}
</script>

<style scoped>

</style>
